import { Dashicon } from '@wordpress/components';
import availableLayouts from './AvailableLayouts';
import {__} from '@wordpress/i18n';
import { infoIcon } from '../Icons';

const NewLayout = () => {
  return (
    <div className="responsive-site-builder-content mt-8">
      <div className="flex gap-6">
        {availableLayouts.map((current, index) => (
          <div key={index} className="relative group shadow-cardShadow transition-shadow duration-300">
              <div className='flex flex-col gap-3 p-6 bg-white rounded-md shadow-md h-full'>
                <div className="flex items-center justify-between">
                  <h3 className="m-0 text-sm text-center font-semibold capitalize leading-[100%]">{current?.key === '404-page' ? '404' : current?.key }</h3>
                  <span className="relative group/info cursor-pointer">
                    <span className="absolute z-50 bottom-full mb-1 left-1/2 -translate-x-1/2 w-max max-w-60 px-2.5 py-2.5 text-[12px] text-gray-700 bg-white border border-gray-200 shadow-md rounded-md whitespace-normal hidden group-hover/info:block hover:cursor-text">
                      {current.desc}
                      <span className="absolute top-full left-[48%] w-2 h-2 bg-white rotate-45 -mt-1 shadow-[0px_4px_8px_0px_#0000001F]"></span>
                    </span>
                    {infoIcon}
                  </span>
                </div>
                <div className="relative">
                  <div className="w-full">
                    <div className="transition group-hover:blur-sm">
                      {current?.image}
                    </div>
                    <button
                      className="absolute inset-0 m-auto w-fit h-fit px-4 py-2 rounded bg-btnPrimary text-white text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center gap-1 hover:bg-sky-600"
                      onClick={() => window.location.href = responsive_addons_site_builder?.admin_url + 'post-new.php?post_type=resp-site-builder&type=' + current.key }
                    >
                      <Dashicon icon="plus-alt2" /> {__( 'Create Layout', 'responsive-addons' )}
                    </button>
                  </div>
                </div>
              </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default NewLayout